// extracted by mini-css-extract-plugin
export default {"sections":"EditForm_sections__03VPt","inputTotalSuffix":"EditForm_inputTotalSuffix__d7X4M","actions":"EditForm_actions__4fUO0"};